import React, {useState} from 'react';
import {Routes, Route, Link} from 'react-router-dom'
import './App.css';
import NavBar from './component/NavBar';
import HomePage from './pages/home';
import ModelManagement from './pages/model-management/router';
import SystemManagement from './pages/system-management/router';
import ImageViewRouter from './pages/image-view/router';
import TeachmodeAPIRouter from './pages/teachmode/router';
import DatasetRouter from './pages/dataset-management/router';
import TeachmodeRouter from './pages/teachmode/router';
import Dashboard from './pages/dashboard';
import AuthPage from './pages/login'
import { AuthProvider, useAuth } from './component/AuthContext';
import ProtectedRoute from './component/ProtectedRoute';
import SignUpPage from './pages/signup';
import RoleManagementRouter from './pages/role-management/router';
import ConfigManagementRouter from './pages/config-management/router';
import MatrixMappingRouter from './pages/matrix-mapping/router';
import VerifyEmailPage from './pages/verify';

function App() {

  const [isNavbarOpen, setIsNavbarOpen] = useState(false)
  const toggleNavbar = () => {
      setIsNavbarOpen((prevState) => !prevState)
  }

  return (
    <>
    <AuthProvider>
    <NavBar isOpen={isNavbarOpen} toggleSidebar={toggleNavbar} />

        <Routes>
          <Route path="/" element={<ProtectedRoute><HomePage/></ProtectedRoute>} />
          <Route path="/dataset-management/*" element={<ProtectedRoute><DatasetRouter/></ProtectedRoute>} />
          <Route path="/image-view/*" element={<ProtectedRoute><ImageViewRouter/></ProtectedRoute>} />
          <Route path="/teachmode/*" element={<ProtectedRoute><TeachmodeRouter/></ProtectedRoute>} />
          <Route path="/api/teachmode/*" element={<ProtectedRoute><TeachmodeAPIRouter/></ProtectedRoute>} />
          <Route path="/model-management/*" element={<ProtectedRoute><ModelManagement/></ProtectedRoute>} /> 
          <Route path="/outflow" />
          <Route path="/system-management/*" element={<ProtectedRoute><SystemManagement/></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/login" element={<AuthPage/>} />
          <Route path="/sign-up" element={<SignUpPage/>} />
          <Route path="/verify-email" element={<VerifyEmailPage/>} />
          <Route path="/role-management/*" element={<ProtectedRoute><RoleManagementRouter/></ProtectedRoute>} />
          <Route path="/config-management/*" element={<ProtectedRoute><ConfigManagementRouter/></ProtectedRoute>} />
          <Route path="/matrix-mapping/*" element={<ProtectedRoute><MatrixMappingRouter/></ProtectedRoute>} />
        </Routes>
      </AuthProvider>
    </>
  );
}

export default App; 
